export default (() => {
    const textareas = Array.from(document.querySelectorAll('textarea.fui-input'));

    const setCount = (field, counter, maxLength) => {
        counter.innerHTML = maxLength - field.value.length;
    };

    textareas.forEach((field) => {
        const maxLength =
            field.getAttribute('maxlength') && Number(field.getAttribute('maxlength'));
        if (!maxLength) return;

        const label = field.parentElement.parentElement.querySelector('label');
        if (label) label.classList.add('mr-10');

        const counter = field.parentElement.querySelector('.Textarea__counter');
        field.addEventListener('input', () => setCount(field, counter, maxLength));
        setCount(field, counter, maxLength);
    });
})();
